const state = {
    machineHealthData: {
    },
}
const getters = {
    get_machineHealthData: state => {
        return state.machineHealthData
    },
}
const actions = {
    set_machineHealthData(context, obj) {
        context.commit('SET_MACHINEHEALTHDATA', obj);
    },
    clear_machineHealthData(context) {
        context.commit('CLEAR_MACHINEHEALTHDATA');
    }
}
const mutations = {
    SET_MACHINEHEALTHDATA(state, obj) {
        state.machineHealthData = obj;
    },
    CLEAR_MACHINEHEALTHDATA(state) {
        state.machineHealthData = {};
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/machineHealth.js